import React, { useState, useRef, useEffect } from "react";

export default function Dropdown({
  items = [],
  value,
  onChange,
  placeholder = "Select…",
  label,
  disabled = false,
  displayValue = null,
  
  // ⭐ NEW PROP - to determine button class
  variant = "default", // "default" or "chatbot"
  
  className = "",
  buttonClass = "",
  menuClass = "",
  itemClass = "",
}) {
  const [open, setOpen] = useState(false);
  const [internalValue, setInternalValue] = useState(null);

  const isControlled = value !== undefined;
  const selectedValue = isControlled ? value : internalValue;

  const selectedItem = items.find((i) => i.value === selectedValue) || null;

  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const handleSelect = (item) => {
    if (!isControlled) setInternalValue(item.value);
    onChange?.(item.value, item);
    setOpen(false);
  };

  // ✅ Determine what text to show when selected
  const displayText = selectedItem
    ? displayValue && selectedItem[displayValue]
      ? selectedItem[displayValue]
      : selectedItem.label
    : placeholder;

  // ✅ CONDITIONAL BUTTON CLASS
  const buttonClassName = variant === "chatbot" 
    ? `language-toggle ${open ? 'active' : ''}` 
    : buttonClass || "form-dropdown-container";

  return (
    <div ref={dropdownRef} style={{ position: "relative" }} className={className}>
      {label && <label className="form-dropdown-name">{label}</label>}

      <button
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        className={buttonClassName}
      >
        {variant === "chatbot" ? (
          <>
            <span className="language-icon">
              {selectedItem?.icon }
            </span>
            <span className="language-text">{displayText}</span>
            <span className={`language-arrow ${open ? 'open' : ''}`}>▼</span>
          </>
        ) : (
          <span className="form-dropdown-item.selected">{displayText}</span>
        )}
      </button>

      {open && (
        <div className={variant === "chatbot" ? "language-dropdown" : menuClass || "form-dropdown-menu"}>
          {items.map((item) => (
            <div
              key={item.value}
              onClick={() => handleSelect(item)}
              className={variant === "chatbot" 
                ? `language-option ${selectedValue === item.value ? 'selected' : ''}` 
                : itemClass || "form-dropdown-item"
              }
            >
              {item.label}
              {variant === "chatbot" && selectedValue === item.value && ' ✓'}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
